<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
    >
      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="ruleForm"
        label-width="110px"
      >
        <el-form-item label="科目名称" prop="name">
          <el-input
            v-model.trim="ruleForm.name"
            style="width: 300px"
            maxlength="10"
            placeholder="请输入科目名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="科目排序" prop="sortNum">
          <el-input
            v-model="ruleForm.sortNum"
            style="width: 300px"
            @input="ruleForm.sortNum = Number(ruleForm.sortNum) || 0"
            maxlength="3"
            placeholder="请输入科目排序"
          ></el-input>
        </el-form-item>
        <el-form-item label="展示状态" prop="status">
          <el-radio-group v-model="ruleForm.status">
            <el-radio :label="1">隐藏</el-radio>
            <el-radio :label="2">显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="dialogBtn_box">
          <el-button size="medium" type="primary" @click="handleAffirm">{{
            btnTitle
          }}</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  addBktSubject,
  updateBktSubject,
} from "@/api/videoReference/account.js";
export default {
  data() {
    return {
      dialogVisible: false,
      dialogStatus: "",
      dialogTitle: "",
      btnTitle: "",
      ruleForm: {
        name: "",
        sortNum: "",
        status: 1,
      },
      rules: {
        name: [
          { required: true, message: "科目名称不能为空", trigger: "blur" },
        ],
        sortNum: [
          { required: true, message: "科目排序不能为空", trigger: "blur" },
        ],
        status: [
          { required: true, message: "展示状态不能为空", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    init(status, payload) {
      this.dialogTitle = status === "add" ? "新增科目" : "编辑科目";
      this.btnTitle = status === "add" ? "新增" : "保存";
      this.dialogStatus = status;
      this.dialogVisible = true;
      this.dataInit(status, payload);
      this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate();
      });
    },
    dataInit(status, payload) {
      if (status === "add") {
        this.ruleForm = {
          name: "",
          sortNum: "",
          status: 1,
        };
      } else if (status === "alter") {
        this.ruleForm = {
          id: payload.id,
          name: payload.name,
          sortNum: payload.sortNum,
          status: payload.status,
        };
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleAffirm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.dialogStatus === "add") {
            addBktSubject(this.ruleForm).then((res) => {
              if (res.code === 0) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.$parent.refresh();
                this.dialogVisible = false;
              }
            });
          } else if (this.dialogStatus === "alter") {
            updateBktSubject(this.ruleForm).then((res) => {
              if (res.code === 0) {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.$parent.refresh();
                this.dialogVisible = false;
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialogBtn_box {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>